var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _vm.$auth.watch.authenticated
        ? _c("v-card-text", { staticClass: "instructions-page content-500" }, [
            _c("h2", { staticClass: "page-title" }, [
              _vm._v("Using The RoomReady App")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-xs-left" }, [
              _c("div", { staticClass: "instructions" }, [
                _c("ol", [
                  _c("li", [
                    _vm._v(
                      "Please make sure you are using either Chrome or Safari (without incognito or private browsing mode)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Select a campus, building and room")]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("Check that all room technology is functional")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "Add notes to inoperable items, or those that required repair"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Submit your room report")])
                ])
              ]),
              _vm._v(" "),
              !!_vm.team && !!_vm.team.preRoundsInstructions
                ? _c("div", { staticClass: "reminders" }, [
                    _c("p", [_vm._v(_vm._s(_vm.team.preRoundsInstructions))])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.$auth.watch.authenticated
              ? _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          to: "/" + _vm.teamId + "/room",
                          color: "primary"
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("forward")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Start Rounds")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", color: "error" },
                        on: {
                          click: function($event) {
                            return _vm.logout()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("exit_to_app")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn__text" }, [
                          _vm._v("Logout")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b3ef1e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3ef1e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamHome.vue
// module id = iCXU
// module chunks = 1